export const apiURL = process.env.REACT_APP_API_URL

export const INITIAL_ACTIONS = {
    edit: false,
    add: false,
    display: false
}

export const phoneRegExp = /^(06|07)\d{8}$/;
export const validePhoneSheetRegex = /^((\+212|212|0)?X?)[5-8]([ .-/]?\d{2}){4}$/
export const roles = [
    'Confirmation messenger',
    'Confirmation whatsApp',
    'Confirmation instagram',
    'Confirmation convertion',
    'Gestion',
    'Suivie',
    'Livreur',
    'super admin',
    'statistique',
];

export const deliveryStatus = [
    'Expedié',
    'Livré',
    'Annulé',
    'Reporté',
    'En cours',
    'Injoignable',
    'Refusé',
    'Ajouté',
    'Ramassé',
    'Change',
    'Changement destinataire',
    'Commande double',
    'Demande de reconfirmation',
    'Demande de retour',
    'En attente de retour',
    'Hors zone / Faux destination',
    'Interessé',
    'Pas de réponse',
    'Prèt pour expédition',
    'Programmé',
    'Receptionné',
    'Retour Client à Expédié',
    'Retour client reçu',
    'Retourné',
    'Retour Livreur à Expédié'
]

export const rolesDoesNotHaveAddOrders = ['super admin', 'suivie', 'livreur']
export const rolesConst = {
    ConfirmationMessenger: 'Confirmation messenger',
    ConfirmationWhatsApp: 'Confirmation whatsApp',
    ConfirmationInstagram: 'Confirmation instagram',
    ConfirmationConvertion: 'Confirmation convertion',
    Management: 'Gestion',
    Follow: 'Suivie',
    Deliveryman: 'Livreur',
    SuperAdmin: 'super admin',
    Statistic: 'statistique',
}
export const confirmationStatus = ['double ordre confirmée', 'Injoignable', 'faux num', 'double ordre', '1ere app', 'Message whatssap', 'confirmée', 'Rappellée', '2 ere app', '3 ere app', 'pas de reponse', 'Annulée', 'Hors zone confirmée','en attente']
export const DeliveryCompaniesConst = {
    Bmd: "BMD",
    Sendit: "Sendit",
    DeliveryMen: "Livreurs"
}
export const DeliveryStatusElement = {
    Shipped: 'Expedié',
    Delivered: 'Livré',
    Canceled: 'Annulé',
    Postponed: 'Reporté',
    InProgress: 'En cours',
    Unreachable: 'Injoignable',
    Refused: 'Refusé',
    Added: 'Ajouté',
    PickedUp: 'Ramassé',
    Changed: 'Change',
    RecipientChanged: 'Changement destinataire',
    DuplicateOrder: 'Commande double',
    NeedFollowUp: 'Demande de reconfirmation',
    ReturnRequested: 'Demande de retour',
    WaitingForReturn: 'En attente de retour',
    OutOfZone: 'Hors zone / Faux destination',
    Interested: 'Interessé',
    NoResponse: 'Pas de réponse',
    ReadyForShipment: 'Prèt pour expédition',
    Scheduled: 'Programmé',
    Received: 'Receptionné',
    ClientReturnShipped: 'Retour Client à Expédié',
    ClientReturnReceived: 'Retour client reçu',
    Returned: 'Retourné',
    CourierReturnShipped: 'Retour Livreur à Expédié',
}
export const ConfirmationStatusElement = {
    DoubleOrderConfirmed: 'double ordre confirmée',
    Unreachable: 'Injoignable',
    WrongNumber: 'faux num',
    DoubleOrder: 'double ordre',
    FirstCall: '1ere app',
    MessageWhatsApp: 'Message whatssap',
    Confirmed: 'confirmée',
    Recalled: 'Rappellée',
    SecondCall: '2 ere app',
    ThirdCall: '3 ere app',
    NoAnswer: 'pas de reponse',
    Cancelled: 'Annulée',
    OutsideConfirmedZone: 'Hors zone confirmée',
    Pending: 'en attente'
};

export const confirmationRoles = [rolesConst.ConfirmationConvertion, rolesConst.ConfirmationInstagram, rolesConst.ConfirmationMessenger, rolesConst.ConfirmationWhatsApp]
export const ManagementRoles = [rolesConst.Management, rolesConst.Follow]
